import React, { useState, useEffect } from 'react';

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null); // Stocke l'événement beforeinstallprompt
  const [isInstalled, setIsInstalled] = useState(false); // État pour savoir si l'application est installée

  useEffect(() => {
    // Écoute l'événement beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Empêche l'affichage automatique de la boîte de dialogue
      setDeferredPrompt(e); // Stocke l'événement pour l'utiliser plus tard
    };

    // Écoute l'événement appinstalled
    const handleAppInstalled = () => {
      setIsInstalled(true); // Met à jour l'état pour indiquer que l'application est installée
      setDeferredPrompt(null); // Réinitialise l'événement
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    // Nettoyage des événements
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Affiche la boîte de dialogue d'installation
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === 'accepted') {
        console.log('L\'utilisateur a accepté l\'installation');
      } else {
        console.log('L\'utilisateur a refusé l\'installation');
      }
      setDeferredPrompt(null); // Réinitialise l'événement après l'utilisation
    }
  };

  return (
    <div>
      {!isInstalled && deferredPrompt && (
        <button onClick={handleInstallClick}>Installer l'application</button>
      )}
    </div>
  );
};

export default InstallPWAButton;